import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private _permissionsSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  public permissions$ = this._permissionsSubject.asObservable();

  constructor() {}

  updatePermissions(newPermissions: string[]) {
    this._permissionsSubject.next(newPermissions);
  }
}
